export default {
    filters: {
        title: "Suodattimet",
        removeFilter: "Poista suodatin",
        filterIntensity: "Suodattimen voimakkuus",
        duotone: {
            title: "Duoton",
            desert: "Autiomaa",
            peach: "Persikka",
            clash: "Yhteentörmäys",
            plum: "Luumu",
            breezy: "Raikas",
            deepBlue: "Syvä sininen",
            frog: "Sammakko",
            sunset: "Auringonlasku",
        },
        blackAndWhite: {
            title: "Mustavalkoinen",
            ad: "1920 A.D.",
            greyed: "Harmaantunut",
            dusty: "Pölyinen",
            litho: "Kivi- tai litografia",
            sepia: "Sepia",
            weathered: "Weathered - Säälitty",
            hardStuff: "Kova aine",
        },
        vintage: {
            title: "Vintage",
            polaroid: "Polaroid",
            sunny: "Aurinkoinen 70-luku",
            oldTimer: "Vanha kunnon aikatyöläinen",
            inferno: "Inferno - Helvetti",
            snappy: "Välitön",
        },
        smooth: {
            title: "Pehmeä",
            chestnut: "Kastanja",
            softy: "Pehmoilija",
            pebble: "Kivi",
            moss: "Sammal",
            lemon: "Sitruuna",
            greenGap: "Vihreä aukko",
        },
        cold: {
            title: "Kylmä",
            colla: "Colla",
            solanus: "Solanus ",
            kalmen: "Kalmen",
            jorah: "Joran",
            levante: "Levante",
            zephyr: "Seepia",
        },
        warm: {
            title: "Lämmin",
            golden: "Kultainen",
            lowFire: "Matala tuli",
            sunrise: "Auringonnousu",
            flatBack: "Litteä selkä",
            pumpkin: "Kurpitsa",
        },
    },
};
